'use client';

import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { INTAKE_CONSENT_OPTIONAL, INTAKE_CONSENT_TEMPLATE } from '../intake-copy';

type Props = {
  institutionName: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export function IntakeConsentRow({
  institutionName,
  checked,
  onChange,
}: Props) {
  const body = INTAKE_CONSENT_TEMPLATE.replace(
    '{institution}',
    institutionName || 'this institution'
  );

  return (
    <FormControlLabel
      sx={{ alignItems: 'flex-start', ml: 0, mr: 0 }}
      control={
        <Checkbox
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          size="small"
          sx={{ pt: 0.25 }}
        />
      }
      label={
        <Stack spacing={0.25} sx={{ pt: 0.15 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: 13, lineHeight: 1.4 }}
          >
            {body}
          </Typography>
          <Typography
            variant="caption"
            color="text.disabled"
            sx={{ fontSize: 11, lineHeight: 1.35 }}
          >
            {INTAKE_CONSENT_OPTIONAL}
          </Typography>
        </Stack>
      }
    />
  );
}
